import React, { useRef, useEffect } from "react";

/**
 * Menu - Dropdown menu component
 * @param {object} props Component props
 * @param {boolean} props.open Whether the menu is open
 * @param {function} props.onClose Function to call when menu should close
 * @param {React.ReactNode} props.children Menu items
 * @param {string} props.className Additional CSS classes
 * @author Forge
 * @date 2026-04-02
 * @version 1.0
 */
export default function Menu({ open, onClose, children, className = "" }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={menuRef}
      className={`topbar-menu ${className}`}
    >
      {children}
    </div>
  );
}
